import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PoolCareComponent } from './pool-care.component';
import { PoolCareRoutingModule } from './pool-care-routing.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
    imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    NgxSpinnerModule,
    PoolCareRoutingModule,
    ReactiveFormsModule,
    PoolCareComponent
]
})
export class PoolCareModule { }
